import { useSearchForm } from './search-form-model';
import { useMultiCitySearchForm } from './multi-city-model';

export const searchFormModel = {
  useSearchForm,
  useMultiCitySearchForm,
};
